import {pino} from "pino";

// preview and production do not use dev logging.
const devLogging = process.env.VERCEL_ENV == null;

/** BUG Datadog not wired to this app (neither server nor client-side)! D: */
export const log = pino({
	level: devLogging ? "debug" : "info",
});
